<template>
  <a-modal
    v-model:open="visible"
    :title="null"
    centered
    width="100%"
    :bodyStyle="{ height: 'calc(100vh - 25px)', padding: '0', position: 'relative' }"
    :footer="null"
    :destroyOnClose="true"
    :closable="false"
    :afterClose="hiddenModal"
  >
    <div style="height: 100%; position: relative">
      <!-- 完成按钮 -->
      <div class="complete-btn" @click="completeImageEditor">
        <ehf-icon class="btn-icon" icon="checkbox-circle-line"></ehf-icon>
      </div>
      <!-- 取消按钮 -->
      <div class="cancel-btn" @click="hiddenModal">
        <ehf-icon class="btn-icon" icon="close-fill"></ehf-icon>
      </div>
      <!-- 编辑器实例 -->
      <div id="tui-image-editor"></div>
    </div>
  </a-modal>
</template>

<script>
  export default {
    name: 'EhfImageEditor',
  }
</script>
<script setup>
  import 'tui-image-editor/dist/tui-image-editor.css'
  import 'tui-color-picker/dist/tui-color-picker.css'
  import ImageEditor from 'tui-image-editor'
  import { ref, onMounted, toRefs, watch, nextTick } from 'vue'
  import dataDictionary from './dataDictionary' //数据字典
  import { isNull, getBase64Img } from '@/utils'
  import { message } from 'ant-design-vue'

  const { customTheme, locale_zh } = dataDictionary() //自定义样式和汉化
  const props = defineProps({
    show: {
      // 是否开启
      type: Boolean,
      default: false,
    },
    toBase64: {
      // 是否需要把图片转base64格式
      type: Boolean,
      default: false,
    },
    src: {
      // 图片链接
      type: String,
      default: null,
    },
    menuList: {
      // 菜单列表
      type: Array,
      default() {
        return ['resize', 'crop', 'rotate', 'draw', 'shape', 'icon', 'text', 'filter']
      },
    },
  })
  const { show, toBase64, src, menuList } = toRefs(props)

  const emit = defineEmits(['update:show', 'complete'])

  const imgEditor = ref(null) //编辑器实例
  const visible = ref(false) // 控制弹窗显示
  const handleUrl = ref(null) //要处理的图片链接图片链接

  //默认菜单包含【'调整宽高','裁切','旋转','画','图形标注（填充遮住内容）','图标标注','文本标注','滤镜'】
  const menuListDefault = ref(['resize', 'crop', 'rotate', 'draw', 'shape', 'icon', 'text', 'filter'])

  //前置判断图片是否需要转base64格式
  const confirmLink = () => {
    if (toBase64.value) {
      getBase64Img(src.value).then((src) => {
        if (!isNull(src)) {
          handleUrl.value = src
          init()
        } else {
          message.error('图片不符合要求')
          hiddenModal()
        }
      })
    } else {
      handleUrl.value = src.value
      init()
    }
  }
  //编辑器实例初始化
  const init = () => {
    imgEditor.value = new ImageEditor(document.querySelector('#tui-image-editor'), {
      includeUI: {
        loadImage: {
          path: handleUrl.value,
          name: 'image',
        },
        menu: menuList.value || menuListDefault, // 底部菜单按钮列表 默认隐藏镜像flip和遮罩mask
        // initMenu: 'draw', // 默认打开的菜单项
        menuBarPosition: 'right', // 菜单所在的位置
        theme: customTheme, // 自定义样式
        locale: locale_zh, // 本地化语言为中文
      },
      cssMaxHeight: 700, //画布最大高度（图片根据画布自适应）
      cssMaxWidth: 1000, //画布最大宽度（图片根据画布自适应）
    })
    document.getElementsByClassName('tui-image-editor-main')[0].style.top = '0' // 图片距顶部工具栏的距离
  }

  //图片编辑完成
  const completeImageEditor = () => {
    // 调用tui.image-editor的保存功能，如果当前处于裁切状态时，完成裁切，否则进catch
    try {
      imgEditor.value.crop(imgEditor.value.getCropzoneRect())
    } catch (e) {
      console.log(e)
    }
    //增加100ms延时，防止图片还没加载完毕，就保存了图片，canvas会画出空白图片
    setTimeout(() => {
      emit('complete', imgEditor.value.toDataURL())
    }, 100)
  }
  //关闭该编辑器
  const hiddenModal = () => {
    emit('update:show', false)
  }

  watch(show, (val) => {
    visible.value = val
    nextTick(() => {
      if (val) {
        confirmLink()
      }
    })
  })

  onMounted(() => {
    if (show.value) confirmLink()
  })
</script>

<style scoped>
  .complete-btn,
  .cancel-btn {
    width: 64px;
    height: 64px;
    position: absolute;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
  }
  .btn-icon {
    font-size: 36px;
  }
  .complete-btn {
    color: #1890ff;
    bottom: 0;
  }
  .cancel-btn {
    top: 0;
  }
</style>
